module.exports = __webpack_public_path__ + "static/media/ont.9cc63857.svg";